module.exports = __webpack_public_path__ + "assets/b99.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b99.png
// module id = 692
// module chunks = 0